import { ViewModel, View, ViewModelMessage } from "binder"
import { AuthenticationViewModel, LoginCompletedMessage, ReloginCompletedMessage } from "src/security/authentication/authentication-viewModel";
import { LocalNotification, LocalNotificationMessage } from "src/server/localNotification";
import { ServerConnection } from "src/server/serverConnection";
import { CreateWindowMessage, UserInactivityLogoutMessage, UserMainWindowViewModel } from "../userMainWindow/userMainWindow-viewModel";
import { MainWindowView } from "./mainWindow-view"
import { ShowMessageBoxMessage } from "src/binder/uiPatterns/mvvm/viewmodel";
import { MediaSelector } from "uicomponents";
import { MainWindowPhoneView } from "./mainWindowPhone/mainWindowPhone-view";
import { CurrentCredentials } from "src/server/currentCredentials";
import { NotAuthenticatedUserMainWindowViewModel } from "../userMainWindow/notAuthenticatedUserMainWindow/notAuthenticatedUserMainWindow-viewModel";
import { stringIsNullOrEmpty } from "../utilities";

export class MainWindowViewModel extends ViewModel {
    private themes: Map<string, string>;
    private fontsClass: Map<string, string>;
    constructor(parentViewModel: ViewModel, formId: string = null) {
        super(parentViewModel);
        this.updateThemeAndFontMappingsMappings();
        this.addonDownloadClosed = false;
        this.shallShowAddonDownload = false;
        this.localNotification = new LocalNotification(() => "", () => "");
        this.localNotification.addonNotFound = () => {
            if (this.addonDownloadClosed == false) {
                this.shallShowAddonDownload = false;
                console.log('failed addon');

            }
        }
        this.localNotification.addonConnected = () => {
            console.log('connected addon');
            this.shallShowAddonDownload = false;
        }
        if (formId) {
            CurrentCredentials.username = "Anonymous";
            CurrentCredentials.password = "Anonymous";
            let notAuthenticatedMainWindow = new NotAuthenticatedUserMainWindowViewModel(this);
            this.content = notAuthenticatedMainWindow;
            let request = new CreateWindowMessage("5ec1473c-34a7-467a-9ec4-b039fa416a8c");
            request.isProcessForm = true;
            request.processFormName = "";
            request.processFormId = formId;
            notAuthenticatedMainWindow.handleMessage(request);

        } else {
            this.content = new AuthenticationViewModel(this);
        }
        this.stableBackground = 'linear-gradient(-45deg, #29323c, #485563)';
        this.transitionBackground = 'linear-gradient(-45deg, #29323c, #485563)';

        this.loadLastBackgroundImageAndFont();
    }

    GetDefaultView(): View<ViewModel> {
        return MediaSelector.GetView({
            desktop: () => new MainWindowView(),
            default: () => new MainWindowPhoneView()
        })
    }
    public getTypeId(): string {
        return "VM-88B5598D-CA0D-4C8B-A023-66AE3131C1BB"
    }
    private localNotification: LocalNotification;

    private updateThemeAndFontMappingsMappings() {
        this.themes = new Map<string, string>();
        this.themes.set('1', '/res/bg1.jpg');
        this.themes.set('2', '/res/bg2.jpg');
        this.themes.set('3', '/res/bg3.jpg');
        this.themes.set('4', '/res/bg4.jpg');
        this.themes.set('5', '/res/bg5.jpg');
        this.themes.set('6', '/res/bg6.jpg');
        this.themes.set('7', 'linear-gradient(45deg, #0c675e, #069e90)');
        this.themes.set('8', 'linear-gradient( 567deg , rgba(165, 42, 4, 0.89), rgba(113, 102, 8, 0.89), rgba(13, 95, 16, 0.93), rgba(4, 79, 88, 0.94), rgba(19, 56, 86, 0.9), rgba(24, 32, 78, 0.94), rgba(100, 8, 115, 0.95))');
        this.themes.set('9', 'linear-gradient(45deg, #29323c, #485563)');
        this.themes.set('10', 'linear-gradient(45deg, #795548, #945c48)');
        this.themes.set('11', 'linear-gradient(45deg, #1565C0, #1E88E5)');
        this.themes.set('12', 'linear-gradient(45deg, #65379b, #886aea)');
        this.themes.set('13', 'linear-gradient(45deg, #000000, #000000);i');
        this.themes.set('14', 'linear-gradient(180deg, #08a50e, #69bb03)');
        this.themes.set('15', 'linear-gradient(45deg, #6a11cb, #2575fc)');
        this.fontsClass = new Map<string, string>();
        this.fontsClass.set('1', '');
        this.fontsClass.set('2', 'yekan-font');
        this.fontsClass.set('3', 'dana-font');


    }
    cancelAddonDownload() {
        this.addonDownloadClosed = true;
        this.shallShowAddonDownload = false;
    }
    downloadURI(uri, name) {
        let link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    downloadAddon() {
        this.downloadURI('/Addon.zip', 'Addon.zip');
        this.shallShowAddonDownload = false;
        this.addonDownloadClosed = true;
    }
    getCurrentThemeId(): string {
        let current = localStorage.getItem("main-window-background-image");
        let currentThemeId = [...this.themes.entries()].filter(x => x[1] == current).at(0)?.[0]
        return currentThemeId;
    }
    handleMessage(message: ViewModelMessage) {
        if (message instanceof LoginCompletedMessage) {
            this.content = new UserMainWindowViewModel(this);
        } else if (message instanceof UserInactivityLogoutMessage) {
            if(this.previousContent==null || this.previousContent==undefined){
                this.previousContent = this.content;
                this.content = new AuthenticationViewModel(this);
            }
        } else if (message instanceof ReloginCompletedMessage) {
            this.content = this.previousContent;
            (this.content as UserMainWindowViewModel).reloadHomaePage();
            this.previousContent = null;
        } else if (message instanceof ShowMessageBoxMessage) {
            return (<any>this.content).ShowMessageBox(message);
        } else if (message instanceof LocalNotificationMessage) {
            return this.localNotification.handleMessage(message)
        } else if (message instanceof ChangeThemeMessage) {

            let themeId = message.background == "ignore" ? (this.getCurrentThemeId() ?? "4") : (message.background ?? "4");
            let background = this.themes.get(themeId);
            if (themeId == null)
                background = '/res/bg4.jpg';
            this.updateBackgroundImage(background);
            let fontId = message.fontId ?? '';
            let fontClass = this.fontsClass.get(fontId);
            if (fontClass == null)
                fontClass = '';
            this.updateFontClass(fontClass);

            if (message.shallSave) {
                this.saveUserTheme(themeId, fontId);
            }
            return null;
        } else {
            return super.handleMessage(message);
        }
    }
    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content; } private _content: ViewModel;
    public set previousContent(v: ViewModel) { this._previousContent = v; } public get previousContent(): ViewModel { return this._previousContent;} private _previousContent: ViewModel;
    public set stableBackground(v: string) { this._stableBackground = v; } public get stableBackground(): string { return this._stableBackground; } private _stableBackground: string;
    public set transitionBackground(v: string) { this._transitionBackground = v; } public get transitionBackground(): string { return this._transitionBackground; } private _transitionBackground: string;
    public set transitioning(v: boolean) { this._transitioning = v; } public get transitioning(): boolean { return this._transitioning; } private _transitioning: boolean;

    public set shallShowAddonDownload(v: boolean) { this._shallShowAddonDownload = v; } public get shallShowAddonDownload(): boolean { return this._shallShowAddonDownload; } private _shallShowAddonDownload: boolean;
    public set addonDownloadClosed(v: boolean) { this._addonDownloadClosed = v; } public get addonDownloadClosed(): boolean { return this._addonDownloadClosed; } private _addonDownloadClosed: boolean;

    async loadLastBackgroundImageAndFont() {
        let backgroundImage = localStorage.getItem("main-window-background-image");
        if (backgroundImage == null) {
            this.updateBackgroundImage('/res/bg4.jpg');
        } else {
            this.updateBackgroundImage(backgroundImage);
        }

        let fontClass = localStorage.getItem("main-window-font-class");
        if (fontClass == null) {
            this.updateFontClass('');
        } else {
            this.updateFontClass(fontClass);
        }
    }

    private readBlob(b): Promise<string> {
        return new Promise(function (resolve, reject) {
            const reader = new FileReader();

            reader.onloadend = function () {
                resolve(<string>reader.result);
            };
            reader.onerror = function () {
                reject();
            }
            // TODO: hook up reject to reader.onerror somehow and try it

            reader.readAsDataURL(b);
        });
    }
    private lastRequestTime;
    async updateBackgroundImage(background: string) {
        let isInverted = background.split(";").at(1) === "i";
        if (isInverted) {
            document.body.classList.add("inverted-theme");
        } else {
            document.body.classList.remove("inverted-theme");
        }
        let realBackground = background.split(";").at(0)
        let requestTime = new Date().getTime();
        let backgroundImage = realBackground;
        this.lastRequestTime = requestTime;
        if (realBackground.startsWith('/res/')) {
            let response = await fetch(realBackground);
            const blob = await response.blob();
            backgroundImage = await this.readBlob(blob);
            backgroundImage = `url('${backgroundImage}')`;
            if (requestTime < this.lastRequestTime)
                return;
        }
        localStorage.setItem("main-window-background-image", background);
        this.applyBackgroundImage(backgroundImage);
    }

    private applyBackgroundImage(content: string) {
        this.stableBackground = content;
        this.transitioning = true;
        setTimeout(() => {
            this.transitionBackground = content;
            this.transitioning = false;
        }, 300)
    }

    async updateFontClass(fontClass: string) {
        let bodyClasses = document.body.classList;
        [...this.fontsClass.values()].filter(x => x != '').forEach(x => bodyClasses.remove(x));
        if (stringIsNullOrEmpty(fontClass) == false) {
            bodyClasses.add(fontClass);
        }
        localStorage.setItem("main-window-font-class", fontClass);

    }
    async saveUserTheme(themeId: string, fontId: string) {
        try {
            let result = await ServerConnection.callServer('/Complex/SecurityRawDataServices/UpdateCurrentUserTheme', {
                ThemeId: `${themeId};${fontId}`
            });
        } catch (ex) {
        } finally {
        }
    }
}

export class ChangeThemeMessage extends ViewModelMessage {
    public background: string;
    public fontId: string;
    public shallSave: boolean;
}

